export enum AddNewTemplateMode {
	actionItemsTemplate = 1,
	actionItem = 2
}